import React, { useEffect, useState } from "react";

import { Button, Col, Form, Modal } from "react-bootstrap";
import { Actions } from "../../../client/Actions";
import { useTranslation } from 'react-i18next';


const ManagementActionDetails = ({ id, setId, icon, title, actionName, size, extended, props, shrink, custom }) => {

  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);

  const [details, setDetails] = useState({ user: null });


  const updateDashboard = () => {
    if (id) {
      Actions.get("/management/" + actionName + "/" + id, callbackGetAction);
    }
  };

  const callbackGetAction = (resp) => {
    setDetails({
      date: resp.date,
      user: resp.user ? resp.user.username: resp.username,
      tool: !shrink ? resp.tool.name : "",
      machine: extended ? resp.machine.name : "",
      filtersAreInGoodTechnicalCondition: resp.filtersAreInGoodTechnicalCondition,
      filtersHaveBeenCleanedOrAreClean: resp.filtersHaveBeenCleanedOrAreClean

    });
    setShowModal(true);


  };

  const handleCloseModal = () => {
    setShowModal(false);
    setId();
  };

  useEffect(updateDashboard, []);


  return (
    <div>
      {details ?
        <Modal show={showModal} onHide={handleCloseModal} size={size || "sm"}>
          <Modal.Header closeButton>
            <Modal.Title><i className={`fas ${icon}`} /> {title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form noValidate>
              <Form.Row>
                <Col>
                  <Form.Group controlId="date_name_control">
                    <Form.Label><strong>{t("common.date")}</strong></Form.Label>
                    <Form.Control
                      name="date_name"
                      value={details.date ? details.date : ""}
                      readOnly={true}
                      type="text"
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <Form.Group controlId="user_name_control">
                    <Form.Label><strong>{t("common.user")}</strong></Form.Label>
                    <Form.Control
                      name="user_name"
                      value={details.user ? details.user : ""}
                      readOnly={true}
                      type="text"
                      placeholder=""
                    />
                  </Form.Group>
                </Col>
              </Form.Row>
              {!shrink ?
                <Form.Row>
                  <Col>
                    <Form.Group controlId="tool_name_control">
                      <Form.Label><strong>{t("actions.agent")}</strong></Form.Label>
                      <Form.Control
                        name="tool_name"
                        value={details.tool ? details.tool : ""}
                        readOnly={true}
                        type="text"
                        placeholder=""
                      />
                    </Form.Group>
                  </Col>
                </Form.Row> : ""}
              {extended ?
                <Form.Row>
                  <Col>
                    <Form.Group controlId="machine_name_control">
                      <Form.Label><strong>{t("common.machine")}</strong></Form.Label>
                      <Form.Control
                        name="tool_name"
                        value={details.machine ? details.machine : ""}
                        readOnly={true}
                        type="text"
                        placeholder=""
                      />
                    </Form.Group>
                  </Col>
                </Form.Row>
                : ""}

              {custom && details && custom(details)}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" className="Modal_btn_submit" onClick={handleCloseModal}>{t("common.continue")}</Button>
          </Modal.Footer>
        </Modal> : ""}
    </div>
  );
};

export default ManagementActionDetails;